import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

function BrandsSection() {
  const brands = [
    { name: 'Brand 1', img: '/images/products/b_01.jpg' },
    { name: 'Brand 2', img: '/images/products/b_02.jpg' },
    { name: 'Brand 3', img: '/images/products/b_03.jpg' },
    { name: 'Brand 4', img: '/images/products/b_04.jpg' },
    { name: 'Brand 5', img: '/images/products/b_05.jpg' },
    { name: 'Brand 6', img: '/images/products/b_06.jpg' },
    { name: 'Brand 7', img: '/images/products/b_07.jpg' },
    { name: 'Brand 8', img: '/images/products/b_08.jpg' },
    { name: 'Brand 9', img: '/images/products/b_09.jpg' },
    { name: 'Brand 10', img: '/images/products/b_10.jpg' },
    { name: 'Brand 11', img: '/images/products/b_11.jpg' },
    { name: 'Brand 12', img: '/images/products/b_12.jpg' },
    { name: 'Brand 13', img: '/images/products/b_13.jpg' },
    { name: 'Brand 14', img: '/images/products/b_14.jpg' },
    { name: 'Brand 15', img: '/images/products/b_15.jpg' },
    { name: 'Brand 16', img: '/images/products/b_16.jpg' },
    { name: 'Brand 17', img: '/images/products/b_17.jpg' },
    { name: 'Brand 18', img: '/images/products/b_18.jpg' },
    { name: 'Brand 19', img: '/images/products/b_19.jpg' },
    { name: 'Brand 20', img: '/images/products/b_20.jpg' },
    { name: 'Brand 21', img: '/images/products/b_21.jpg' },
    { name: 'Brand 22', img: '/images/products/b_22.jpg' },
    { name: 'Brand 23', img: '/images/products/b_23.jpg' },
    { name: 'Brand 24', img: '/images/products/b_24.jpg' },
    { name: 'Brand 25', img: '/images/products/b_25.jpg' },
    { name: 'Brand 26', img: '/images/products/b_26.jpg' },
    { name: 'Brand 27', img: '/images/products/b_27.jpg' },
  ];
  
  const [start, setStart] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  
  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Adjust visible items based on screen size
  const visible = isMobile ? 1 : 6;
  const end = start + visible;
  const canPrev = start > 0;
  const canNext = end < brands.length;
  
  const handlePrev = () => canPrev && setStart(start - (isMobile ? 1 : 1));
  const handleNext = () => canNext && setStart(start + (isMobile ? 1 : 1));
  
  const navigate = useNavigate();
  const handleViewMore = () => navigate('/brands');

  return (
    <section className="brands-section">
      <div className="brands-inner">
        <div className="brands-title-wrap">
          <h2 className="brands-title">OUR BRANDS</h2>
          <div className="brands-title-underline"></div>
        </div>
        <div className="brands-carousel-wrap">
          <button className="brands-nav brands-nav-left" onClick={handlePrev} disabled={!canPrev}>
            <span>&lt;</span>
          </button>
          <div className="brands-carousel">
            {brands.slice(start, end).map((brand, idx) => (
              <div className="brand-card" key={brand.name + idx}>
                <img src={brand.img} alt={brand.name} className="brand-logo" />
              </div>
            ))}
          </div>
          <button className="brands-nav brands-nav-right" onClick={handleNext} disabled={!canNext}>
            <span>&gt;</span>
          </button>
        </div>
        <div className="brands-btn-wrap">
          <button className="brands-btn" onClick={handleViewMore}>VIEW MORE</button>
        </div>
      </div>
    </section>
  );
}

export default BrandsSection; 